import Vue from 'vue'
import Vuex from 'vuex'

import global from './modules/global'
import my from './modules/my'
import main from './modules/main'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
      global,
      my,
      main
    }
})

export default store
